module.exports = __webpack_public_path__ + "img/40_69_008_820.0bf2d6de.jpg";